export default __webpack_public_path__ + "static/media/drybag_6l.353603c1.jpg";